type IssueKey = string;
type ProjectKey = string;

/**
 * Extracts the project key from an issue key.
 *
 * The project key is the part of the issue key before the first dash.
 * If there is no dash, the entire string is returned as the project key.
 *
 * @param issueKey - The issue key string (e.g., 'PROJ-123', 'TEST-1')
 * @returns The project key extracted from the issue key
 *
 * @example
 * // Standard issue keys
 * extractProjectKey('PROJ-123') // Returns 'PROJ'
 * extractProjectKey('TEST-1') // Returns 'TEST'
 * extractProjectKey('ABC-999') // Returns 'ABC'
 *
 * @example
 * // Issue keys with multiple dashes (only first part is extracted)
 * extractProjectKey('PROJ-123-456') // Returns 'PROJ'
 * extractProjectKey('TEST-1-2-3') // Returns 'TEST'
 *
 * @example
 * // Issue keys without dashes (entire string is returned)
 * extractProjectKey('PROJ') // Returns 'PROJ'
 * extractProjectKey('TEST') // Returns 'TEST'
 *
 * @example
 * // Edge cases
 * extractProjectKey('') // Returns ''
 * extractProjectKey('-123') // Returns ''
 * extractProjectKey('PROJ-') // Returns 'PROJ'
 */
export const extractProjectKey = (issueKey: IssueKey): ProjectKey => issueKey.split('-')[0];
